import React from 'react'
import { toneColor, convictionTone } from '../../utils/tone'

export default function ConvictionBar({ value, label = 'Conviction' }) {
  const color = toneColor(convictionTone(value))
  const pct = Math.round(value * 100)

  return (
    <div>
      <div className="flex justify-between items-center mb-1">
        <span className="text-[11px] uppercase tracking-wider text-[var(--onds-text-dim)]">{label}</span>
        <span className="text-xs font-semibold" style={{ color }}>{pct}%</span>
      </div>
      <div className="h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: 'var(--onds-border)' }}>
        <div
          className="h-full rounded-full transition-all duration-700"
          style={{ width: `${pct}%`, backgroundColor: color }}
        />
      </div>
    </div>
  )
}
